import React from "react";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
  RouterProvider,
} from "react-router-dom";
import { useSelector } from "react-redux";


import Layout from "./components/layout";
import RootLayout from "./components/layout/RootLayout";
import Login from "./pages/login";
import Logout from "./pages/logout";
import ProtectedRoute from "./components/ProtectedRoute";
import AllPackages from "./pages/allPackages";
import Hotels from "./pages/hotels";
import HotelLinkReview from "./pages/hotels/HotelLinkReview";
import Vehicles from "./pages/vehicle";
import Users from "./pages/users";
import UserSummary from "./pages/users/UserSummary";
import Dashboard from "./pages/dashboard";
import Query from "./pages/query";
import Itinerary from "./pages/itinerary";
import AdditionalCost from "./pages/additionalCost";
import CreateItinerary from "./pages/createItinerary";
import withAuthRedirect from "./components/withAuthRedirect";
import View from "./components/packages/View";
import Edit from "./components/packages/Edit";
import NotAuthorized from "./pages/NotAuthorized";
import SingleQueriesView from "./pages/query/SingleQueriesView";
import PackageCreate from "./components/packages/packageForm";
import PlacesForm from "./components/places/placesForm";
import CtgForm from "./components/category-packages/ctgForm";
import AllPlaces from "./pages/allPlaces";
import CategoryPackage from "./pages/categoryPackage";
import ImageManagerPage from "./pages/imageManager";
import PackageUploadInPlaces from "./pages/packageUpload/inPlaces";
import CategoryPackageUploadInPlaces from "./pages/packageUpload/inCategoryPackage";
import AllPermissions from "./pages/allPermissions";
import LocationsPage from "./pages/locations";
import Sayantan from "./pages/sayantan";
import Profile from "./pages/Profile";
import People from "./pages/people";
import WhatsappInbox from "./pages/whatsappInbox";
import Teams from "./pages/teams";
import Holidays from "./pages/holidays";
import Leaves from "./pages/leaves";
import Attendance from "./pages/attendance";
import HRManagement from "./pages/hr-management";
import VerifiedLeads from "./pages/verified-leads";
import EasoGuestsPage from "./pages/easo-guests/index.js";
import ConfirmBookingPage from "./pages/confirm-booking/index.js";
import ItineraryStore from "./pages/itinerary-store";
import DestinationItineraryStore from "./pages/destination-itinerary-store";
import ItineraryCardsPage from "./pages/itinerary-cards";
import ProbationEvaluation from "./pages/hr-management/ProbationEvaluation";
import ProbationEvaluationList from "./pages/hr-management/ProbationEvaluationList";
import ProbationEvaluationSingle from "./pages/hr-management/ProbationEvaluationSingle";
import Announcements from "./pages/announcements";
const RootLayoutWithRedirect = withAuthRedirect(RootLayout);

// Provide the router
const Router = () => {
  const { user } = useSelector(state => state.tokens);

  const router = React.useMemo(() => createBrowserRouter(
    createRoutesFromElements(
      <>
        {/* Public routes */}
        <Route path="/" element={<RootLayoutWithRedirect />}>
          <Route index element={<Login />} />
          <Route path="logout" element={<Logout />} />
        </Route>

        {/* Protected routes */}
        <Route path="/" element={<Layout />}>
          <Route
            path="dashboard"
            element={<ProtectedRoute Element={Dashboard} module="dashboard" />}
          />
          <Route
            path="query"
            element={<ProtectedRoute Element={Query} module="queries" />}
          />
          <Route
            path="inquiry"
            element={<ProtectedRoute Element={Itinerary} module="inquiry" />}
          />
          <Route
            path="createItinerary"
            element={<ProtectedRoute Element={CreateItinerary} module="inquiry" />}
          />
          <Route
            path="packages"
            element={<ProtectedRoute Element={AllPackages} module="packages" />}
          />
          {/* Profiles & directory: open to every logged-in user (no module gate) */}
          <Route
            path="profile"
            element={<ProtectedRoute Element={Profile} />}
          />
          <Route
            path="profile/:userId"
            element={<ProtectedRoute Element={Profile} />}
          />
          <Route
            path="people"
            element={<ProtectedRoute Element={People} />}
          />
          <Route
            path="hotels"
            element={<ProtectedRoute Element={Hotels} module="hotel" />}
          />
          <Route
            path="hotels/link-review"
            element={<ProtectedRoute Element={HotelLinkReview} />}
          />
          <Route
            path="Vehicles"
            element={<ProtectedRoute Element={Vehicles} module="Vehicles" />}
          />
          <Route
            path="packages/view/:id"
            element={<ProtectedRoute Element={View} module="packages" />}
          />
          <Route
            path="packages/createandedit"
            element={<ProtectedRoute Element={PackageCreate} module="packages" />}
          />
          <Route
            path="packages/:locationSegment"
            element={<ProtectedRoute Element={AllPackages} module="packages" />}
          />
          <Route
            path="packages/:locationSegment/:searchSegment"
            element={<ProtectedRoute Element={AllPackages} module="packages" />}
          />
          <Route
            path="category-packages/createandedit"
            element={<ProtectedRoute Element={CtgForm} module="packages" />}
          />
          <Route
            path="category-packages/view"
            element={<ProtectedRoute Element={CategoryPackage} module="packages" />}
          />
          <Route
            path="upload/categorypackages/:id"
            element={<ProtectedRoute Element={CategoryPackageUploadInPlaces} module="places" />}
          />
          <Route
            path="locations"
            element={<ProtectedRoute Element={LocationsPage} module="locations" />}
          />
          <Route
            path="places"
            element={<ProtectedRoute Element={AllPlaces} module="places" />}
          />
          <Route
            path="places/createandedit"
            element={<ProtectedRoute Element={PlacesForm} module="places" />}
          />
          <Route
            path="places/view"
            element={<ProtectedRoute Element={AllPlaces} module="places" />}
          />
          <Route
            path="places/view/:zoneSegment"
            element={<ProtectedRoute Element={AllPlaces} module="places" />}
          />
          <Route
            path="places/view/:zoneSegment/:searchSegment"
            element={<ProtectedRoute Element={AllPlaces} module="places" />}
          />
          <Route
            path="upload/:schema/:id"
            element={<ProtectedRoute Element={ImageManagerPage} module="places" />}
          />
          <Route
            path="upload/packages/:id"
            element={<ProtectedRoute Element={PackageUploadInPlaces} module="places" />}
          />
          <Route
            path="query/view/:id"
            element={<ProtectedRoute Element={SingleQueriesView} module="queries" />}
          />
          <Route
            path="query/view"
            element={<ProtectedRoute Element={SingleQueriesView} module="queries" />}
          />
          <Route
            path="packages/edit"
            element={<ProtectedRoute Element={Edit} module="packages" />}
          />
          <Route
            path="costTable"
            element={<ProtectedRoute Element={AdditionalCost} module="costs" />}
          />
          <Route
            path="users"
            element={<ProtectedRoute Element={Users} module="user" />}
          />
          <Route
            path="users/:userId/summary"
            element={<ProtectedRoute Element={UserSummary} module="user" />}
          />
          <Route
            path="users/summary"
            element={<ProtectedRoute Element={UserSummary} module="user" />}
          />
          <Route
            path="permission"
            element={<ProtectedRoute Element={AllPermissions} module="permission" />}
          />
          {user?.permission === 'Admin' && (
            <Route
              path="sayantan"
              element={<ProtectedRoute Element={Sayantan} module="sayantan" />}
            />
          )}
          <Route
            path="whatsapp-inbox"
            element={<ProtectedRoute Element={WhatsappInbox} module="whatsapp" />}
          />
          <Route
            path="teams"
            element={<ProtectedRoute Element={Teams} module="teams" />}
          />
          <Route
            path="holidays"
            element={<ProtectedRoute Element={Holidays} module="holidays" />}
          />
          <Route
            path="leaves"
            element={<ProtectedRoute Element={Leaves} module="leaves" />}
          />
          <Route
            path="attendance"
            element={<ProtectedRoute Element={Attendance} module="attendance" />}
          />
          <Route
            path="verified-leads"
            element={<ProtectedRoute Element={VerifiedLeads} module="verified-leads" />}
          />
          <Route
            path="easo-guests"
            element={<ProtectedRoute Element={EasoGuestsPage} module="easo-guests" />}
          />
          <Route
            path="confirm-booking"
            element={<ProtectedRoute Element={ConfirmBookingPage} module="confirm-booking" />}
          />
          <Route
            path="hr-management"
            element={<ProtectedRoute Element={HRManagement} module="hr-management" />}
          />
          <Route
            path="itinerary-store"
            element={<ProtectedRoute Element={ItineraryStore} module="itinerary-store" />}
          />
          <Route
            path="destination-itinerary-store"
            element={<ProtectedRoute Element={DestinationItineraryStore} module="destination-itinerary-store" />}
          />
          <Route
            path="itinerary-cards"
            element={<ProtectedRoute Element={ItineraryCardsPage} module="itinerary-cards" />}
          />
          <Route
            path="announcements"
            element={<ProtectedRoute Element={Announcements} module="announcements" />}
          />
          <Route
            path="probation-evaluation"
            element={<ProtectedRoute Element={ProbationEvaluation} module="hr-management" />}
          />
          <Route
            path="hr-management/probation-evaluation-list"
            element={<ProtectedRoute Element={ProbationEvaluationList} module="hr-management" />}
          />
          <Route
            path="hr-management/probation-evaluation/view/:id"
            element={<ProtectedRoute Element={ProbationEvaluationSingle} module="hr-management" />}
          />
          <Route path="not-authorized" element={<NotAuthorized />} />
        </Route>
      </>
    ),
    {
      future: {
        v7_startTransition: true,
        v7_relativeSplatPath: true,
        v7_fetcherPersist: true,
        v7_normalizeFormMethod: true,
        v7_partialHydration: true,
        v7_skipActionErrorRevalidation: true,
      },
    }
  ), [user?.permission]);

  return <RouterProvider router={router} />;
};

export default Router;
